import css from 'styled-jsx/css'
import { colors } from '../../styles'

const {
  primaryText,
} = colors

export default css`
.ScrollableList {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-right: 0px;
}

.list-outer {
  margin-left: 3px;
  height: 46px;
  overflow-y: hidden;
  overflow-x: auto;
  position: relative;
  border-bottom: 2px solid #c4c4c463;
}

.list-outer.banner {
  border-bottom: 0px;
}

.list-outer.overlay{
  height: 250px !important;
}
.list-outer.tv-guide{
  height: auto;
  margin-left: 0px;
}
.list-outer.banner, ul {
  height: 64px;
}

ul {
  margin: 0;
  padding: 4px 16px 25px;
  display: inline-flex;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  justify-content: space-between;
  height: 55px;
  gap: 24px;
}
ul.overlay{
  border: none;
   height: auto;
    display: block;
    padding: 0px;
}

.list-outer.live-dropdown {
  height: auto;
  border: none;
  padding-bottom: 8px;
}

ul.live-dropdown {
  padding: 0px;
  gap: 8px;
}

ul.overlay.position{
    justify-content: flex-start !important;
}

.scroller-button {
  position: absolute;
  top: 0;
  bottom: 4px;
  opacity: 1;
  transition: 150ms all;
  color: ${primaryText};
  border: 0;
  background-color: transparent;
  z-index: 3;
  padding-top: 4px;
}

.scroller-button.background{
  width: 32px;
  transform: scale(1);
  transition: 200ms transform;
  border-radius: 4px;
}

.scroller-button span {
  display: block;
  position: absolute;
  text-indent: -9999px;
}

.scroller-button:hover, .scroller-button:focus {
  cursor: pointer;
  color: ${primaryText};
  transform: scale(1.75);
}

.scroller-button:disabled {
  opacity: 0;
  pointer-events: none;
}

.nofocus {
  outline: 0;
}

.scroll-left {
  bottom: 10px;
  padding-right: 30px;
  padding-left: 10px;
  left: 0;
  /* Safari has buggy handling of the transparent keyword in gradients,
  so use an RGBA colour instead. */
  background-image: linear-gradient(to right,
    #151515 0,
    rgba(21, 21, 21, 0.00) 65.10%);
}

.scroll-left.tv-guide{
  top: 5px;
  }
.scroll-right.background {
  padding-right: 30px;
  padding-left: 10px;
  right: 15px;
}

.scroll-right.tv-guide{
top: 5px;
}

.scroll-right {
  bottom: 10px;
  padding-right: 10px;
  padding-left: 40px;
  right: 0;
  background-image: linear-gradient(to left,
    #151515 0,
    rgba(21, 21, 21, 0.00) 65.10%);
}
::-webkit-scrollbar { display: none; }


@media (min-width: 768px) {
  .list-outer, ul {
    height: 46px;
  }
  .ScrollableList {
    padding-right: 16px;
  }
  ul.overlay{
      justify-content: center;
      display: flex;
  }
  .list-outer.live-dropdown{
    padding-bottom: 24px;
    text-align: center;
  }
  
  .list-outer.tv-guide{
    height: 302px !important;
  }
}
`
